module.exports = __webpack_public_path__ + "static/coming_soon_bg-aefaf54902c9cfe48cfc957c7e94d8e2.png";